module.exports = __webpack_public_path__ + "static/media/collection-bird-08.c5955780.png";